import logo from '@/assets/logalto-logo-white.png';

type Props = { className?: string };

export function LogaltoLogo({ className = 'h-8 w-auto' }: Props) {
	return (
		<img
			src={logo}
			alt="LogAlto"
			className={className}
		/>
	);
}
